const timeZone = "Asia/Tokyo";

export function formatTime(value: string) {
  return new Intl.DateTimeFormat("ja-JP", { timeZone, hour: "2-digit", minute: "2-digit", hour12: false }).format(new Date(value));
}

export function formatDateTime(value: string) {
  return new Intl.DateTimeFormat("ja-JP", { timeZone, month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }).format(new Date(value));
}

export function newsPeriodStart(days: string, now = new Date()): string {
  if (days !== "1") return new Date(now.getTime() - Number(days) * 86_400_000).toISOString();
  const tokyoDate = new Date(now.getTime() + 9 * 3_600_000).toISOString().slice(0, 10);
  return new Date(`${tokyoDate}T00:00:00+09:00`).toISOString();
}
